import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const UserOutlinedSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.0648 6.65401C17.0648 3.29017 14.3393 0.564728 10.9755 0.564728C7.61163 0.564728 4.88619 3.29017 4.88619 6.65401C4.88619 8.68705
      5.88306 10.4893 7.41521 11.5942C7.40538 11.5991 7.39802 11.6016 7.39311 11.604C6.29556 12.0681 5.31096 12.7335 4.46387 13.583C3.62166
      14.4237 2.95115 15.4203 2.48976 16.5172C2.0358 17.5913 1.7908 18.7421 1.76788 19.908C1.76723 19.9342 1.77182 19.9603 1.7814 19.9847C1.79098
      20.0091 1.80534 20.0314 1.82365 20.0501C1.84196 20.0689 1.86383 20.0838 1.88799 20.094C1.91215 20.1041 1.9381 20.1094 1.96431 20.1094H3.43507C3.54065
      20.1094 3.62904 20.0234 3.6315 19.9179C3.68061 18.0223 4.43931 16.2471 5.78239 14.9016C7.16967 13.5094 9.01119 12.7433 10.9755 12.7433C14.3393 12.7433
      17.0648 10.0179 17.0648 6.65401ZM10.9755 10.8772C8.64288 10.8772 6.75226 8.9866 6.75226 6.65401C6.75226 4.32142 8.64288 2.4308 10.9755
      2.4308C13.3081 2.4308 15.1987 4.32142 15.1987 6.65401C15.1987 8.9866 13.3081 10.8772 10.9755 10.8772ZM13.5536 16.3036H20.0357C20.1438
      16.3036 20.2322 16.2152 20.2322 16.1071V14.7321C20.2322 14.6241 20.1438 14.5357 20.0357 14.5357H15.702L16.861 13.06C16.8877 13.0256
      16.9024 12.9833 16.9027 12.9397C16.9027 12.8317 16.8143 12.7433 16.7063 12.7433H14.9237C14.8034 12.7433 14.6904 12.7998 14.6143 12.8931L12.9324
      15.0317C12.8244 15.1692 12.7654 15.3411 12.7654 15.5179C12.7679 15.9525 13.119 16.3036 13.5536 16.3036V16.3036ZM19.4465 17.875H12.9643C12.8563
      17.875 12.7679 17.9634 12.7679 18.0714V19.4464C12.7679 19.5545 12.8563 19.6429 12.9643 19.6429H17.298L16.1391 21.1185C16.1124 21.153 16.0977
      21.1952 16.0973 21.2388C16.0973 21.3469 16.1857 21.4353 16.2938 21.4353H18.0764C18.1967 21.4353 18.3096 21.3788 18.3857 21.2855L20.0677
      19.1469C20.1757 19.0094 20.2346 18.8375 20.2346 18.6607C20.2322 18.2261 19.8811 17.875 19.4465 17.875V17.875Z"
      fill="currentColor"
    />
  </svg>
);

const UserOutlined = (props: IIconProps) => <Icon component={UserOutlinedSvg} {...props} />;

export default UserOutlined;
